import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a38d12fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "accordion-item__header" }
const _hoisted_3 = { class: "accordion-item__indicator" }
const _hoisted_4 = ["aria-expanded", "aria-describedby", "disabled"]
const _hoisted_5 = { class: "accordion-item__title" }
const _hoisted_6 = ["id"]
const _hoisted_7 = {
  key: 0,
  class: "accordion-item__info-button"
}
const _hoisted_8 = ["aria-hidden"]

import { computed } from 'vue';
import { useStore } from 'vuex';
import { uniqueId } from 'lodash';
import AccordionIndicator from './AccordionIndicator.vue';
import InfoButton from '../UI/InfoModal/OpenButton.vue';
import InfoModal from '../UI/InfoModal/InfoModal.vue';
import MeasurementsHeightTransition from '@/components/UI/MeasurementsHeightTransition.vue';
import { StepTypes } from '@/types/step';

interface Props {
	stepName: StepTypes;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AccordionItem',
  props: {
    stepName: {}
  },
  setup(__props: any) {

const props = __props;
const store = useStore();
const i18n = window.measurementSelectorVariables.i18n;

const step = computed(() => store.getters.getStepById(props.stepName));
const currentStepName = computed(() => store.getters.currentStepName);
const isCurrent = computed(() => currentStepName.value === props.stepName);

const htmlId = uniqueId('accordion-item-');
const variant = computed((): 'valid' | 'empty' | 'error' => {
	if (step.value.status === 'completed') {
		return 'valid';
	}
	if (step.value.status === 'invalid') {
		return 'error';
	}
	return 'empty';
});

if (!currentStepName.value) { // if no current step, set first one
	store.commit('updateCurrentStepName', props.stepName);
}

function updateCurrentStep() {
	store.commit('updateCurrentStepName', props.stepName);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(['accordion-item', `accordion-item--${variant.value}`]),
    "aria-label": step.value.shortTitle
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(AccordionIndicator, { variant: variant.value }, null, 8, ["variant"])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "accordion-item__button",
          onClick: updateCurrentStep,
          type: "button",
          "aria-expanded": isCurrent.value,
          "aria-describedby": step.value.text && !isCurrent.value ? _unref(htmlId) : null,
          disabled: isCurrent.value
        }, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(step.value.title), 1)
        ], 8, _hoisted_4),
        _createVNode(MeasurementsHeightTransition, {
          appear: false,
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (step.value.text || isCurrent.value)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "accordion-item__selection-info",
                  id: _unref(htmlId)
                }, [
                  _createVNode(_Transition, { name: "accordion-fade" }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("span", null, _toDisplayString(step.value.status === 'invalid' ? _unref(i18n).stepError : step.value.text), 513), [
                        [_vShow, step.value.text && !isCurrent.value]
                      ])
                    ]),
                    _: 1
                  })
                ], 8, _hoisted_6))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      (step.value.information)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(InfoButton, {
              "modal-name": _ctx.stepName,
              label: _unref(i18n).modalTriggerLabel
            }, null, 8, ["modal-name", "label"]),
            _createVNode(InfoModal, {
              "modal-name": _ctx.stepName,
              content: step.value.information
            }, null, 8, ["modal-name", "content"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(MeasurementsHeightTransition, {
      appear: false,
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          class: "accordion-item__content",
          "aria-hidden": !isCurrent.value
        }, [
          _renderSlot(_ctx.$slots, "default", { stepName: _ctx.stepName })
        ], 8, _hoisted_8), [
          [_vShow, isCurrent.value]
        ])
      ]),
      _: 3
    })
  ], 10, _hoisted_1))
}
}

})